import { render, staticRenderFns } from "./DragError.vue?vue&type=template&id=6ada9da6&"
import script from "./DragError.vue?vue&type=script&lang=js&"
export * from "./DragError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports